import { render, staticRenderFns } from "./EditInformation.vue?vue&type=template&id=cb8b0630"
import script from "./EditInformation.vue?vue&type=script&lang=ts"
export * from "./EditInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports